// extracted by mini-css-extract-plugin
module.exports = {"stickyButtonContainer":"az_Bcb","applyBtn":"az_Ccb"};